import * as yup from 'yup';
import { API as yachts } from '../../yachts/api';

export const MoveToConf = {
  schema: yup.object({
    id_new_yacht: yup.object().nullable().required('Yacht is required'),
  }),
  defaultValues: {
    id_new_yacht: null,
  },
  fields: [
    {
      id: 'id_new_yacht',
      name: 'id_new_yacht',
      type: 'async_autocomplete',
      label: 'Choose a yacht where to move these operations',
      api: yachts.selectNoAttendanceNoDraft,
      required: true,
      xs: 12,
    },
  ],
};
